import React, { useEffect, useRef } from 'react';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css';
import cloudBackupImg1 from '../../../../assets/services/hostedinfrastructure/icons/infrastructure.svg';

const DisasterSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];

    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-text" ref={textRef}>
          <h1>Enterprise-Grade Cloud-Hosting & Next-Gen Security</h1>
          <p>
            With Synectiks Cloud Hosted Services, you can focus on business outcomes instead of spending time and money planning, procuring, securing, and managing infrastructure. Synectiks Secure Cloud Hosting enables you to run servers, workloads, Kubernetes clusters, websites, and modern applications with strong security, reliable performance, and predictable costs.
          </p>
          <p>
            We provide infrastructure, security controls, backup/DR, and 24×7 operations support - allowing your team to focus on delivery instead of hardware management, procurement, upgrades, and day‑to‑day infrastructure overhead.
          </p>

        </div>
        <div className="end-user-image" ref={imageRef}>
          <img src={cloudBackupImg1} alt="Cloud Backup Illustration" />
        </div>
      </div>
    </section>
  );
};

export default DisasterSection;
